<script>
import VConversationSidebar from './VConversationSidebar';

export default {
  name: 'VSidebarContainer',
  components: { VConversationSidebar },
};
</script>

<template>
  <VConversationSidebar />
</template>
